import React from 'react';
import styled from '@emotion/styled';

const DtmfKeypad = styled.div`
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 12px;
    padding: 15px;
    width: 250px;

    .dtmf-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;

        button {
            font-family: 'Roboto', sans-serif;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: #333;
            color: white;
            font-size: 24px;
            border: none;
            cursor: pointer;

            &:active {
                background-color: #555;
            }
        }
    }

    .keypad-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        justify-content: center;
        margin-bottom: 18px;
        color: white;

        h3 {
            margin: 0;
            font-size: 24px;
        }

        button {
            background: none;
            border: none;
            color: white;
            cursor: pointer;
            padding: 5px;
        }
    }
`;

const DTMF = ({
    showDtmfKeypad,
    callStatus,
    session,
    dtmfInput,
    setDtmfInput,
}) => {
    // Add DTMF feature for component
    const sendDtmf = (digit) => {
        console.log(`Sending DTMF: ${digit}`);
        setDtmfInput(dtmfInput + digit);
        if (session && session.isEstablished()) {
            session.sendDTMF(digit);
        }
    };

    return (
        <DtmfKeypad
            style={{
                visibility:
                    showDtmfKeypad && callStatus === 'active'
                        ? 'visible'
                        : 'hidden',
                opacity: showDtmfKeypad && callStatus === 'active' ? 1 : 0,
                transition: 'visibility 0.2s, opacity 0.2s',
            }}
        >
            <div className="keypad-header">
                <h3 style={{ height: '1.5rem' }}>{dtmfInput}</h3>
            </div>
            <div className="dtmf-grid">
                {[
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '*',
                    '0',
                    '#',
                ].map((digit) => (
                    <button key={digit} onClick={() => sendDtmf(digit)}>
                        {digit}
                    </button>
                ))}
            </div>
        </DtmfKeypad>
    );
};

export default DTMF;
